module.exports = __webpack_public_path__ + "img/mirror35.82357488.jpg";